import uniqueId from '@form-create/utils/lib/unique';
import { makeRequiredRule } from '../../utils';
var label = '附件';
var name = 'uploadFrom';
export default {
  icon: 'iconfont iconfujian',
  label: label,
  name: name,
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      props: {},
      title: '附件',
      info: ''
    };
  },
  props: function props() {
    return [makeRequiredRule()];
  },
  basic: function basic() {}
};